import { client } from "../api";

export default {
  createLead(body) {
    return client.post(`lead`, body);
  },
  createClient(body) {
    return client.post(`client`, body);
  },
  createAddress(uuid, body) {
    return client.post(`client/${uuid}/address`, body)
  },

  updateHostRequested(uuid) {
    return client.put(`client/${uuid}`)
  },

  login(body) {
    return client.post(`auth`, body);
  },
  refreshToken(token) {
    return client.post(`auth/refresh_token?refreshToken=${encodeURIComponent(token)}`);
  },

  loginPublic() {
    return client.post("auth", {
      mail: "public@public.com",
      password: "T12345678w",
    });
  },

  verificaReserva(uuid) {
    return client.get(`client/${uuid}/reservations`);
  },

  addCarToFavorites(uuid, uuidCar) {
    return client.post(`client/${uuid}/favorite/car/${uuidCar}`);

  },

  pay(body) {
    return client.post(`ticket/charge_deposit`, body);
  },

  postReservationImage(payload) {
    return client.post(
      `reservation/${payload.uuid}/image?type=${payload.type}&carSection=${payload.carSection}&comments=${payload.comments}`,
      payload.formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },
  postHostImage(payload) {
    return client.post(
      `client/${payload.uuid}/file?type=${payload.type}`,
      payload.formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },

  updateToS3(url, file) {
    return client.put(
      url,
      file,
      {
        headers: {
          "Content-Type": "image/jpeg",
        },
      }
    );
  },

  updateReservationStatus(payload) {
    return client.put(
      `reservation/${payload.uuid}/status?uuidStatus=${payload.uuidStatus}`
    );
  },
  getEstatus() {
    return client.get(
      `reservation/status`
    );
  },

  getClient(uuid) {
    return client.get(`client/${uuid}`);
  },
  getReservacionesCliente(uuid) {
    return client.get(`client/${uuid}/reservations`);

  },
  getFavorites(uuid) {
    return client.get(`client/${uuid}/favorite/car`);
  },
  getReviews(uuid) {
    return client.get(`client/${uuid}/reviews`);
  },
  updateAvatar(uuid) {
    return client.post(`client/${uuid}/profile_image`);
  },
  resetPassword(payload) {
    return client.put(`client/reset_password`, payload);
  },
  verifyOTP(payload) {
    return client.post(`verify/phone/otp`, payload);
  },
  validaOTP(payload) {
    return client.put(`verify/phone/otp`, payload);
  },

  updateClient(body) {
    return client.put(`client`, body);
  },






};
